// extracted by mini-css-extract-plugin
export var searchHeader = "_2b-0";
export var searchHeaderDark = "_2b-1";